import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { FolderType } from '../constants';
import type { FolderGoodsCardItem } from '../utils/convertFolderGoodsItemToGoodsData';

export const useLogClickGoods = (folderType: FolderType) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    (goods: FolderGoodsCardItem) => {
      logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: {
          ...goods.logging.analytics,
          FOLDER_TYPE: folderType,
        },
        ably_only_log: goods.logging.ably_only_log,
      });

      if (isNotNil(goods.ad)) {
        bridge.logAdEvent({ action: AdAction.CLICK, ad: goods.ad });
      }
    },
    [logAnalyticsEvent, folderType],
  );
};
